/**
 * Loại thu
 */
export default {
  // Tiền
  Money: 0,
  // / Hiện vật
  Artifact: 1,
  // / Ngày công
  WorkDay: 2,
};
